import React, { useState } from 'react';
import TrimCardImage from '../trims/TrimCardImage/TrimCardImage';
import PriceWithDisclaimer from '../priceWithDisclaimer/PriceWithDisclaimer';
import Radio from 'core/controls/radio/Radio';
import GridCard, {
  GridCardPrimarySection,
  GridCardSecondarySection,
} from '../../../components/cards/gridCard/GridCard';
import { combineClassNames } from '../../../../core/css';
import {
  Accordion,
  AccordionContent,
  AccordionGroup,
  AccordionHeader,
} from '../../../../core/controls/accordion/Accordion';
import { Translate, TranslateHTML } from '../../../../core/translate';
import HtmlListWithDisclosures from '../../../common/HtmlListWithDisclosures';

const ModelCard = ({
  disclaimer,
  checked,
  onChange,
  option,
  isUpdating,
  isUpdatingOption,
  wait,
  animation,
  primaryHeight,
  primaryRef,
  secondaryHeight,
  secondaryRef,
}) => {
  const ANALYTICS_KEY = 'models';
  const {
    description,
    cgiImageUrl,
    featuresLabel,
    featureDisclaimers,
    formattedFeatures,
    featureTitle,
    moreFeatureDisclaimers,
    moreFeatures,
    msrp,
    msrpText,
    msrpAsShown,
    msrpAsShownText,
    shortCfd,
    disclaimers,
  } = option;

  const [isOpen, setIsOpen] = useState(false);

  const onClick = () => {
    onChange(option);
  };

  const Features = ({
    featureTitle,
    formattedFeatures,
    featureDisclaimers,
    contentRef,
    height,
  }) => {
    if (!formattedFeatures) {
      return null;
    }
    return (
      <div
        ref={contentRef}
        className="model-card__features_container"
        style={height ? { height: `${height}px` } : {}}>
        {featureTitle && (
          <span
            className="model-card__features-header"
            dangerouslySetInnerHTML={{ __html: featureTitle }}
          />
        )}
        <HtmlListWithDisclosures
          className="model-card__features"
          content={formattedFeatures}
          disclosures={featureDisclaimers}
        />
      </div>
    );
  };

  const AdditionalOptions = ({ moreFeatureDisclaimers, moreFeatures }) => {
    const onIsOpenChanged = (isOpen) => {
      setIsOpen(isOpen);
    };

    const onClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Accordion>
        <AccordionGroup
          isOpenDefault={isOpen}
          className={combineClassNames(
            'model-card__accordion-item',
            moreFeatures ? '' : 'model-card__accordion-item--hidden'
          )}>
          <div onClick={onClick}>
            <AccordionHeader
              expandIcon="expand"
              collapseIcon="collapse"
              alignButtonLeft
              className="model-card__accordion-header"
              onIsOpenChanged={onIsOpenChanged}
              analyticsKey={`${ANALYTICS_KEY}:${description}`}>
              {isOpen ? (
                <TranslateHTML value="view.fewer.features.v3" />
              ) : (
                <TranslateHTML value="view.more.features.v3" />
              )}
            </AccordionHeader>
          </div>

          <AccordionContent className="model-card__accordion-content">
            <Features
              formattedFeatures={moreFeatures}
              featureDisclaimers={moreFeatureDisclaimers}
            />
          </AccordionContent>
        </AccordionGroup>
      </Accordion>
    );
  };

  return (
    <div>
      <GridCard
        checked={checked}
        onClick={onClick}
        isUpdating={isUpdating}
        isUpdatingOption={isUpdatingOption}
        wait={wait}
        animation={animation}>
        <div
          className={combineClassNames('body-card__container', 'stat-wrapper')}
          data-dtm={ANALYTICS_KEY}
          data-dtm2={description}>
          <div
            ref={primaryRef}
            style={primaryHeight ? { height: `${primaryHeight}px` } : {}}>
            <TrimCardImage cgi={cgiImageUrl} trimName={option.trimName} />
            {option.subHeader && (
              <div className="model-card__image--subheader">
                {option.subHeader}
              </div>
            )}

            <GridCardPrimarySection>
              <Radio
                className="model-card__radio control--top"
                analyticsKey={ANALYTICS_KEY}
                analyticsKey2={description}
                checked={checked}>
                <span>{description}</span>
              </Radio>
              {shortCfd && (
                <HtmlListWithDisclosures
                  className="model-card__description"
                  content={shortCfd}
                  disclosures={disclaimers}
                />
              )}
            </GridCardPrimarySection>
          </div>
          <div className="model-card__price-container">
            {(msrp || msrpText) && (
              <div className="option__disclaimer">
                <PriceWithDisclaimer
                  message={msrpText}
                  value={msrp}
                  disclaimer={disclaimer}
                  useModal
                />
              </div>
            )}
            <div>
              {!msrpAsShown && (msrpAsShownText || msrpAsShown) && (
                <span className="as-shown-option__price-label">
                  <Translate value="component.pricing.as.shown.v3" />{' '}
                </span>
              )}
              {(msrpAsShownText || msrpAsShown) && (
                <PriceWithDisclaimer
                  classIdentifier="as-shown"
                  label="component.pricing.as.shown.v3"
                  message={msrpAsShownText}
                  value={msrpAsShown}
                  disclaimer={disclaimer}
                  useModal
                />
              )}
            </div>
          </div>
          <GridCardSecondarySection className="model-card__secondary">
            <Features
              contentRef={secondaryRef}
              height={secondaryHeight}
              label={featuresLabel}
              featureTitle={featureTitle}
              formattedFeatures={formattedFeatures}
              featureDisclaimers={featureDisclaimers}
            />
            <AdditionalOptions
              moreFeatureDisclaimers={moreFeatureDisclaimers}
              moreFeatures={moreFeatures}
            />
          </GridCardSecondarySection>
        </div>
      </GridCard>
    </div>
  );
};

export default ModelCard;
